export enum ReportFilterTypeEnum {
  MoreRegistrations = 1,
  LessRegistrations = 2,
  MoreProgress = 3,
  LessProgress = 4,
  MostCompleted = 5,
  LessCompleted = 6,
}
